import React,{Component} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Badge,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Card
} from 'reactstrap';

import classnames from 'classnames';

import qs from 'query-string';

import {
  getDetailUserSell,
  updateSellRequest,
  deleteSellRequest,
  addSellImageApi,
  updateSellImage,
  deleteSellImageApi,
  getUserSellJournal
} from '../../actions/sellRequestAction';
import { uploadImage, deleteImage } from "../../actions/imageUploadAction";
import { attachRack, detachRack } from "../../actions/rackAction";
import { forceHolidayMode } from '../../actions/userSettingAction';
import SellRequestContainer from './sellRequestDetail/SellRequestContainer';
import ModalViewLogs from './sellRequestDetail/ModalViewLogs';
import UserContainer from './sellRequestDetail/UserContainer';
import ProductContainer from './sellRequestDetail/ProductContainer';
import privateView from '../../components/hocs/privateView';
import Icon from '../../components/Icons/FontAwesomeIcon';
import { ImagesCompressor, createUploadFileForm, getCacheImage, readFile } from '../../utils/imageHelper';
import { getRotatedImg } from '../../utils/imageHelper/cropImage';
import { getPathS3 } from '../../utils/AWS';
import {
	PROCESS_IMAGE_SELL_MODIFIED_STATE,
  PROCESS_IMAGE_SELL_DELETED_STATE
} from '../../constants';
import Analytics from "../../services/Analytics";

const IMAGE_ACTION_DELETE = 'delete';
const IMAGE_ACTION_REPLACE = 'replace';
const IMAGE_ACTION_ROTATE = 'rotate';
const ROTATION_SOURCE_WIDTH = 8192;
const ROTATION_JPEG_QUALITY = 1;

const normalizeRotation = rotation => ((rotation % 360) + 360) % 360;

const isJpegFile = file => {
  if(!file) return false;
  if(file.type === 'image/jpeg') return true;
  return (/\.jpe?g$/i).test(file.name || '');
}

const getImageMimeType = image => {
  const fileType = image?.fileInput?.type;
  if(fileType === 'image/png') return 'image/png';
  if(fileType === 'image/jpeg') return 'image/jpeg';

  const imageUrl = decodeURIComponent((image?.URL || image?.previewURL || '').split('?')[0]);
  return (/\.png$/i).test(imageUrl) ? 'image/png' : 'image/jpeg';
}

const getImageFileExtension = mimeType => mimeType === 'image/png' ? 'png' : 'jpg';

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  flex-wrap: wrap;
`;

const HeaderItem = styled.div`
  margin-bottom: .5rem;
  margin-right: ${props => props.special? "0px":".5rem"};
  font-style: ${props => props.special? "italic":"normal"};
  display: ${props => props.hidden? "none":"block"};
  padding: ${props => props.special? "0rem 0.5rem": "0rem"};
`;

const Header = props => (
  <div>
    <div style={{display: 'flex', alignItems: 'center'}}>
      <h5>{props.displayName}</h5>
      {
        props.category && (
          <Badge color="primary" className="text-uppercase ml-1 mb-2">
            <Icon iconType="tags"/> {props.category}
          </Badge>
        )
      }
    </div>
    <HeaderWrapper>
      <HeaderItem>
        <Icon iconType="calendar"/> {props.createdAt}
      </HeaderItem>
      <HeaderItem>
        <Icon iconType="user"/> {props.userEmail}
      </HeaderItem>
      <HeaderItem
        special
        hidden={!props.roles.includes('trusted_seller')}
      >
        <Icon iconType="check-circle"/> Trusted.
      </HeaderItem>
    </HeaderWrapper>
  </div>
)

class SellRequestDetail extends Component {
	constructor(props) {
		super(props);
    const DEFAULT_STATE = {
      activeTab:'sellRequestDetail',
      id: parseInt(this.props.match.params.id)
    }
    const { id, activeTab } = Object.assign(DEFAULT_STATE,qs.parse(props.location.search));
		this.state={
      id,
      activeTab,
      fetchWhenLoad: true,
      _imageChanged:false,
      _newImagesQueue: [],
      _existingImageQueue:[],
      _images:[],
      _indexImage: null,
      _imageIdProcessed: null,
      _imageActionProcessed: null,
      _isUploadImageCollapse: false,
      _isViewLogsModalOpen: false
		}
    this.toggleTab = this.toggleTab.bind(this);
    this._handleUpdate = this._handleUpdate.bind(this);
    this._handleForceHolidayMode = this._handleForceHolidayMode.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleToggleUploadImageCollapse = this._handleToggleUploadImageCollapse.bind(this);
    this._handleDropMultipleFiles = this._handleDropMultipleFiles.bind(this);
    this._handleDeleteDraftImage = this._handleDeleteDraftImage.bind(this);
    this._handleStartUploadClick = this._handleStartUploadClick.bind(this);
    this._handleRemoveImage = this._handleRemoveImage.bind(this);
    this._handleRotateImage = this._handleRotateImage.bind(this);
    this._handleCancelImageRotation = this._handleCancelImageRotation.bind(this);
    this._handleSaveImageRotation = this._handleSaveImageRotation.bind(this);
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
		this.props.getDetail(this.state.id);
    Analytics.recordPageView('sell_request_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _mapImageFromApi(img){
    return {
      ...img,
      previewURL: img.signed_url || img.URL,
      pendingRotation: 0,
      fileInput: null,
      isPreparingRotation: false,
      isQueued: false,
      imageAction: null,
      rollbackImage: null
    }
  }

  _getUploadPayload(fileInput){
    return createUploadFileForm(fileInput, false, {name: "seller-upload-products/"+this.state.id, bucket_type: "assets"});
  }

  async _prepareUploadFile(file){
    let fileInput = file;
    if(isJpegFile(fileInput)){
      fileInput = await ImagesCompressor(fileInput);
    }

    fileInput.preview = await readFile(fileInput);
    return fileInput;
  }

  _getUploadedImageUrl(uploadData){
    const data = uploadData?.data || uploadData;
    const uploadedImages = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [data];
    const uploadedImage = uploadedImages.find(item => item?.url || item?.URL);
    return uploadedImage?.url || uploadedImage?.URL || null;
  }

  _getImageSourceUrls(image, mimeType){
    const displaySource = image.previewURL || image.signed_url || image.URL;
    const displaySourceUrl = displaySource ? getCacheImage(displaySource, ROTATION_SOURCE_WIDTH, { withoutEnlargement: true }) : null;
    const rawSourceUrls = [image.signed_url, image.URL, image.previewURL]
      .filter(Boolean)
      .filter((url, index, urls) => urls.indexOf(url) === index);

    return (mimeType === 'image/jpeg' ? [displaySourceUrl] : [displaySourceUrl, ...rawSourceUrls])
      .filter(Boolean)
      .filter((url, index, urls) => urls.indexOf(url) === index);
  }

  async _createRotatedImageFile(image, rotation){
    const mimeType = getImageMimeType(image);
    const extension = getImageFileExtension(mimeType);
    const fileName = `sell-request-${this.state.id}-image-${image.id}-rotated.${extension}`;
    const sourceUrls = this._getImageSourceUrls(image, mimeType);
    let lastError = null;

    for(const sourceUrl of sourceUrls){
      try{
        return await getRotatedImg(sourceUrl, rotation, ROTATION_JPEG_QUALITY, mimeType, fileName);
      }
      catch(error){
        lastError = error;
      }
    }

    throw lastError || new Error('Image source is unavailable');
  }

  _getImageError(error, fallbackMessage = 'Image update failed. Please try again.'){
    return {
      message: error?.message || error?.error?.message || error?.response?.data?.message || fallbackMessage
    }
  }

  _getRollbackImage(image){
    return {
      URL: image.URL,
      signed_url: image.signed_url,
      previewURL: image.previewURL,
      pendingRotation: 0
    }
  }

  _rollbackImageOnError(image, error){
    const rollbackImage = image.rollbackImage || {};
    return {
      ...image,
      ...rollbackImage,
      previewURL: rollbackImage.previewURL || image.signed_url || image.URL || image.previewURL,
      pendingRotation: 0,
      fileInput: null,
      isPreparingRotation: false,
      isProcessed: false,
      isQueued: false,
      isDeleted: false,
      imageAction: null,
      rollbackImage: null,
      error: error || image.error || this._getImageError(null)
    }
  }

  _normalizeProcessedImage(image){
    return {
      ...image,
      previewURL: image.signed_url || image.URL || image.previewURL,
      pendingRotation: 0,
      fileInput: null,
      isPreparingRotation: false,
      isProcessed: false,
      isQueued: false,
      isDeleted: false,
      imageAction: null,
      rollbackImage: null,
      error: null
    }
  }

  _startExistingImageProcess(image){
    if(!image) return;

    if(image.imageAction === IMAGE_ACTION_DELETE || image.isDeleted){
      const payload = {
        bucket_type : 'assets',
        name : getPathS3(image.URL)
      };
      this.props.deleteImage(payload);
      return;
    }

    if(image.fileInput){
      this.props.uploadImage(this._getUploadPayload(image.fileInput), image);
      return;
    }

    const payload = {
      user_sell_id: this.state.id,
      URL:image.URL,
    }
    this.props.modifyImage(image.id, image, payload, null)
  }

  _queueOrStartExistingImageProcess(image, imageAction){
    const inOtherProcess = this.state._imageIdProcessed !== null;
    const imageForState = {
      ...image,
      imageAction,
      isPreparingRotation: false,
      isProcessed: !inOtherProcess,
      isQueued: inOtherProcess,
      error: null
    };
    const imageForQueue = {
      ...imageForState,
      isProcessed: true,
      isQueued: false
    };

    this.setState({
      _imageChanged: imageAction !== IMAGE_ACTION_DELETE ? true : this.state._imageChanged,
      _imageIdProcessed: inOtherProcess ? this.state._imageIdProcessed : image.id,
      _imageActionProcessed: inOtherProcess ? this.state._imageActionProcessed : imageAction,
      _existingImageQueue: inOtherProcess
        ? [ ...this.state._existingImageQueue, imageForQueue ]
        : this.state._existingImageQueue,
      _images: this.state._images.map(item =>
        item.id === image.id ? imageForState : { ...item }
      )
    }, ()=>{
      if(!inOtherProcess){
        this._startExistingImageProcess(imageForState);
      }
    });
  }

  _startNextExistingImageProcess(updatedImages){
    const { _existingImageQueue } = this.state;
    if(_existingImageQueue.length>0){
      const [nextImage, ...remainingQueue] = _existingImageQueue;
      const imageAction = nextImage.imageAction || (nextImage.isDeleted ? IMAGE_ACTION_DELETE : IMAGE_ACTION_REPLACE);
      const nextImages = updatedImages.map(img =>
        img.id === nextImage.id
          ? { ...img, ...nextImage, imageAction, isPreparingRotation: false, isProcessed: true, isQueued: false, error: null }
          : { ...img }
      );
      this.setState({
        _imageIdProcessed: nextImage.id,
        _imageActionProcessed: imageAction,
        _imageChanged: imageAction !== IMAGE_ACTION_DELETE,
        _existingImageQueue: remainingQueue,
        _images: nextImages
      }, ()=>{
        const image = this.state._images.find(img=>img.id === nextImage.id);
        this._startExistingImageProcess(image);
      });
      return;
    }

    this.setState({
      _imageIdProcessed: null,
      _imageActionProcessed: null,
      _imageChanged: false,
      _images: updatedImages
    });
  }

  _handleExistingImageUploadError(error){
    const imageError = this._getImageError(error, 'Image upload failed. Please try again.');
    this.setState({
      _imageIdProcessed: null,
      _imageActionProcessed: null,
      _imageChanged: false,
      _existingImageQueue: [],
      _images: this.state._images.map(img =>
        img.id === this.state._imageIdProcessed
          ? this._rollbackImageOnError(img, imageError)
          : { ...img, isPreparingRotation: false, isProcessed: false, isQueued: false }
      )
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!this.props.sellRequest.isFetch && prevProps.sellRequest.isFetch!==this.props.sellRequest.isFetch){
      const { detail, error } = this.props.sellRequest;
      if(error){
        this.props.history.replace(`/${error.status_code}`);
      }
      else{
        this.setState({
          fetchWhenLoad: false,
          _images: detail.user_sell_images.map(img => this._mapImageFromApi(img)),
        })
      }
    }
    if(prevProps.imageUpload.isUpload && prevProps.imageUpload.isUpload !== this.props.imageUpload.isUpload){
      const { success, error } = this.props.imageUpload;
      if(!error){
        const { _newImagesQueue, _imageIdProcessed, _images, _indexImage, _imageChanged, id } = this.state;
        const filtered = _images.filter(img => img.id=== _imageIdProcessed);
        const uploadedImageUrl = this._getUploadedImageUrl(success.data);
        if(!uploadedImageUrl){
          if(this.state._isUploadMultipleFiles){
            this.setState({
              _indexImage: null,
              _imageIdProcessed: null,
              _isUploadMultipleFiles: false,
            });
          }
          else{
            this._handleExistingImageUploadError(this._getImageError(null, 'Uploaded image URL is missing. Please try again.'));
          }
          return;
        }
        const payload = {
          user_sell_id:id,
          URL: uploadedImageUrl,
        }
        if(_imageChanged && filtered.length>0 && !this.state._isUploadMultipleFiles){
          this.props.modifyImage(_imageIdProcessed, filtered[0], payload, null)
        }
        else{
          this.props.newImage(_newImagesQueue[_indexImage], payload, null);
        }
      }
      else{
        if(this.state._isUploadMultipleFiles){
          this.setState({
            _isUploadMultipleFiles: false,
          });
        }
        else{
          this._handleExistingImageUploadError(error);
        }
      }
    }
    if(prevProps.imageUpload.isDeleteProgress && prevProps.imageUpload.isDeleteProgress !== this.props.imageUpload.isDeleteProgress) {
      const { _imageIdProcessed, _images } = this.state;
      const filtered = _images.filter(img => img.id=== _imageIdProcessed);
      if(filtered.length>0)
        this.props.deleteSellImage(filtered[0]);
    }
    if(this.state._imageIdProcessed !== null
      && !this.props.sellRequest.isImageProcessLoading
      && prevProps.sellRequest.isImageProcessLoading !== this.props.sellRequest.isImageProcessLoading){
      const processType = prevProps.sellRequest.imageProcessedState;
      if(processType === PROCESS_IMAGE_SELL_MODIFIED_STATE){
        if(this.state._isUploadMultipleFiles){
          const { _newImagesQueue, _indexImage } = this.state;
          const { imageProcessedResponse } = this.props.sellRequest;
          if(imageProcessedResponse && !imageProcessedResponse.error){
            const hasQueue = _indexImage + 1 < _newImagesQueue.length;
            const newImagesQueue = _newImagesQueue.map((item, index) =>
              index === _indexImage? this._normalizeProcessedImage(imageProcessedResponse) : item
            )
            if(hasQueue)
              newImagesQueue[_indexImage + 1].isProcessed = true;
            this.setState({
              _indexImage: hasQueue? _indexImage + 1 : null,
              _imageIdProcessed: hasQueue? newImagesQueue[_indexImage + 1].id : null,
              _newImagesQueue: hasQueue? newImagesQueue : [],
              _images: hasQueue?this.state._images : [ ...this.state._images, ...newImagesQueue ],
              _isUploadMultipleFiles: hasQueue,
              _isUploadImageCollapse: hasQueue
            }, ()=>{
              if(hasQueue){
                const { _indexImage, _newImagesQueue } = this.state;
                this.props.uploadImage(this._getUploadPayload(_newImagesQueue[_indexImage].fileInput), _newImagesQueue[_indexImage]);
              }
            })
          }
          else{
            const images = _newImagesQueue.map((item, index) =>
              index === _indexImage? { ...imageProcessedResponse }: item
            );
            const completedImages = images.filter( item => item.statusCode===200);
            const failedAndQueueImages = images.filter( item => item.statusCode!==200);
            this.setState({
              _indexImage: null,
              _imageIdProcessed: null,
              _newImagesQueue: failedAndQueueImages,
              _images: [ ...this.state._images, ...completedImages ],
              _isUploadMultipleFiles: false
            })

          }
        }
        else{
          const { imageProcessedResponse } = this.props.sellRequest;
          if(imageProcessedResponse && !imageProcessedResponse.error){
            const updatedImages = this.state._images.map(img =>
              img.id === imageProcessedResponse.id
                ? this._normalizeProcessedImage(imageProcessedResponse)
                : { ...img }
            );
            this._startNextExistingImageProcess(updatedImages);
          }
          else if(imageProcessedResponse && imageProcessedResponse.error) {
            this.setState({
              _imageIdProcessed: null,
              _imageActionProcessed: null,
              _imageChanged: false,
              _existingImageQueue: [],
              _images: this.state._images.map(img => {
                if(img.id === imageProcessedResponse.id)
                  return this._rollbackImageOnError({ ...img, ...imageProcessedResponse }, imageProcessedResponse.error)
                return { ...img, isPreparingRotation: false, isProcessed: false, isQueued: false }
              })
            });
          }
        }
      }
      else if(processType === PROCESS_IMAGE_SELL_DELETED_STATE){
        const { imageProcessedResponse } = this.props.sellRequest;
        if(imageProcessedResponse && !imageProcessedResponse.error){
          const updatedImages = this.state._images.filter(img => img.id !== imageProcessedResponse.id);
          this._startNextExistingImageProcess(updatedImages);
        }
        else if(imageProcessedResponse && imageProcessedResponse.error) {
          this.setState({
            _imageIdProcessed: null,
            _imageActionProcessed: null,
            _imageChanged: false,
            _existingImageQueue: [],
            _images: this.state._images.map(img => {
              if(img.id === imageProcessedResponse.id){
                return this._rollbackImageOnError({ ...img, ...imageProcessedResponse }, imageProcessedResponse.error)
              }
              return { ...img, isPreparingRotation: false, isProcessed: false, isQueued: false, isDeleted: false }
            })
          });

        }
      }
    }
    if(!prevState._isViewLogsModalOpen && prevState._isViewLogsModalOpen !== this.state._isViewLogsModalOpen){
      this.props.getUserSellJournal(this.state.id);
    }
  }

	toggleTab(tab) {
		if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
      const { pathname } = this.props.location;
      const search = qs.stringify({
        activeTab: tab
      });
      this.props.history.push({ pathname, search })
		}
  }

  _getActiveTab(){
    const { activeTab }  = this.state;
    switch(activeTab){
      case "sellerDetail": return "sellerDetail";
      case "productDetail": return "productDetail";
      default: return "sellRequestDetail";
    }
  }

  _isLoading(){
    return this.state.fetchWhenLoad
  }

  _handleUpdate(payload){
    this.props.updateSellRequest(this.state.id, payload);
  }

  _handleForceHolidayMode(payload){
    this.props.forceHolidayMode(payload)
  }

  _handleDelete(id){
    this.props.deleteSellRequest(id);
  }

  async _handleUploadImage(files, evt) {
    const imageId = Number(evt.target.id.split('-')[1]);
    const image = this.state._images.find(item => item.id === imageId);
    if(!image || !files || !files[0]) return;

    try{
      const fileInput = await this._prepareUploadFile(files[0]);
      this._queueOrStartExistingImageProcess({
        ...image,
        fileInput,
        previewURL: fileInput.preview,
        pendingRotation: 0,
        rollbackImage: this._getRollbackImage(image)
      }, IMAGE_ACTION_REPLACE);
    }
    catch(error){
      this.setState({
        _images: this.state._images.map(item =>
          item.id === imageId
            ? { ...item, error: this._getImageError(error, 'Image preparation failed. Please try again.') }
            : { ...item }
        )
      });
    }
  }

  _handleRemoveImage(evt, indexImg){
    evt.preventDefault();
    const image = this.state._images[indexImg];
    if(!image) return;

    this._queueOrStartExistingImageProcess({
      ...image,
      isDeleted: true,
      pendingRotation: 0,
      rollbackImage: this._getRollbackImage(image)
    }, IMAGE_ACTION_DELETE);
  }

  _handleToggleUploadImageCollapse(){
    this.setState({
      _isUploadImageCollapse: !this.state._isUploadImageCollapse
    })
  }

  async _handleDropMultipleFiles(dataAccepted, dataRejected, evt){
    const droppedFiles = await Promise.all(dataAccepted.map(async(file) => {
      const fileInput = await this._prepareUploadFile(file);
      return {
        fileInput,
        previewURL: fileInput.preview,
        isProcessed: false,
        isUploaded: false
      }
    }));
    this.setState(prevState => ({
      _newImagesQueue: [
        ...prevState._newImagesQueue,
        ...droppedFiles.map((file, index) => ({
          ...file,
          id: `new-${prevState._newImagesQueue.length + index}`
        }))
      ]
    }))
  }

  _handleStartUploadClick(){
    if(this.state._newImagesQueue.length>0){
      const draftImages = [ ...this.state._newImagesQueue ];
      draftImages[0].isProcessed = true;
      this.setState({
        _indexImage: 0,
        _imageIdProcessed:draftImages[0].id,
        _isUploadMultipleFiles: true,
        _newImagesQueue: [...draftImages]
      }, ()=>{
        const { _newImagesQueue } = this.state;
        this.props.uploadImage(this._getUploadPayload(_newImagesQueue[0].fileInput), _newImagesQueue[0]);
      });
    }
  }

  _handleRotateImage(imageId, rotation){
    this.setState({
      _images: this.state._images.map(img => {
        if(img.id !== imageId || img.isPreparingRotation || img.isProcessed || img.isQueued) return { ...img };
        return {
          ...img,
          pendingRotation: normalizeRotation((img.pendingRotation || 0) + rotation),
          error: null
        }
      })
    });
  }

  _handleCancelImageRotation(imageId){
    this.setState({
      _images: this.state._images.map(img =>
        img.id === imageId
          ? { ...img, pendingRotation: 0, error: null }
          : { ...img }
      )
    });
  }

  async _handleSaveImageRotation(imageId){
    const image = this.state._images.find(img => img.id === imageId);
    const pendingRotation = normalizeRotation(image?.pendingRotation || 0);
    if(!image || !pendingRotation || image.isPreparingRotation || image.isProcessed || image.isQueued) return;

    const rollbackImage = this._getRollbackImage(image);
    this.setState(prevState => ({
      _images: prevState._images.map(img =>
        img.id === imageId
          ? { ...img, isPreparingRotation: true, error: null }
          : { ...img }
      )
    }));

    try{
      const fileInput = await this._createRotatedImageFile(image, pendingRotation);
      fileInput.preview = await readFile(fileInput);
      this._queueOrStartExistingImageProcess({
        ...image,
        fileInput,
        previewURL: fileInput.preview,
        isPreparingRotation: false,
        pendingRotation: 0,
        rollbackImage
      }, IMAGE_ACTION_ROTATE);
    }
    catch(error){
      const imageError = this._getImageError(error, 'Image rotation failed. Please try again.');
      this.setState(prevState => ({
        _images: prevState._images.map(img =>
          img.id === imageId
            ? this._rollbackImageOnError({ ...img, rollbackImage, isPreparingRotation: false }, imageError)
            : { ...img }
        )
      }));
    }
  }

  _handleDeleteDraftImage(evt, id){
    evt.preventDefault();
    const { _newImagesQueue } = this.state;
    this.setState({
      _newImagesQueue: _newImagesQueue.filter(img => img.id !== id).map((img, index) => ({...img, id: `new-${index}`}))
    });
  }

  _renderContent(){
    const { user, product_variant, size, ...sellRequest } = this.props.sellRequest.detail;
    return(
      <Row>
        <ModalViewLogs
          isOpen={this.state._isViewLogsModalOpen}
          toggle={() => this.setState({_isViewLogsModalOpen: !this.state._isViewLogsModalOpen})}
          isLoading={this.props.sellRequest.journalList.isFetch}
          data={this.props.sellRequest.journalList.data}
          statusCode={this.props.sellRequest.journalList.status_code}
          from={this.props.sellRequest.journalList.from}
          to={this.props.sellRequest.journalList.to}
          currentPage={this.props.sellRequest.journalList.current_page}
          perPage={this.props.sellRequest.journalList.per_page}
          lastPage={this.props.sellRequest.journalList.last_page}
          total={this.props.sellRequest.journalList.total}
          onNextPage={(query) => this.props.getUserSellJournal(this.state.id, query)}
        />
        <Col xs="12">
          {
            !this._isLoading()?
            <Header
              category={product_variant?.product?.category?.name ?? ""}
              displayName={product_variant?.display_name ?? ""}
              createdAt={sellRequest.created_at}
              userEmail={user?.email ?? ""}
              roles={user?.roles?.map(item => item.name) ?? []}
            />
            :null
          }
        </Col>
        <Col xs={12}>
          <Nav className="nav-tabs--custom" tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: this._getActiveTab() === 'sellRequestDetail' })}
                onClick={() => { this.toggleTab('sellRequestDetail'); }}
              >
                {sellRequest?.consignment ? "Consignment" : "Sell"} Request
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this._getActiveTab() === 'productDetail' })}
                onClick={() => { this.toggleTab('productDetail'); }}
              >
                Product Detail
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this._getActiveTab() === 'sellerDetail' })}
                onClick={() => { this.toggleTab('sellerDetail'); }}
              >
                Seller Detail
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent className="tab-content--custom" activeTab={this._getActiveTab()} style={{marginBottom:25}}>
            <TabPane className="tab-content--custom__tab-pane" tabId="sellRequestDetail">
              <SellRequestContainer
                sellRequestId={this.state.id}
                brand={product_variant?.product?.brand ?? null}
                categoryListing={product_variant?.product?.category?.name?.toUpperCase() || 'SNEAKERS'}
                isViewLogsOpen={this.state._isViewLogsModalOpen}
                onViewLogsToggle={() => this.setState({_isViewLogsModalOpen: !this.state._isViewLogsModalOpen})}
                isLoading={this._isLoading()}
                user={user}
                userSetting={this.props.userSetting}
                sellRequest={{...sellRequest}}
                rackDetail={this.props.rackDetail}
                size={size}
                images={this.state._images}
                draftImages={this.state._newImagesQueue}
                dataSellRequest={this.props.sellRequest}
                isUploadImageLoading={this.state._isUploadMultipleFiles}
                isUploadImageCollapse={this.state._isUploadImageCollapse}
                attachRack={this.props.attachRack}
                detachRack={this.props.detachRack}
                handleUpdateSellRequest={this._handleUpdate}
                handleForceHolidayMode={this._handleForceHolidayMode}
                handleDeleteSellRequest={this._handleDelete}
                handleRemoveImage={this._handleRemoveImage}
                handleChangeImage={this._handleUploadImage.bind(this)}
                handleRotateImage={this._handleRotateImage}
                handleCancelImageRotation={this._handleCancelImageRotation}
                handleSaveImageRotation={this._handleSaveImageRotation}
                handleToggleUploadImageCollapse={this._handleToggleUploadImageCollapse}
                handleDropMultipleFiles={this._handleDropMultipleFiles}
                handleDeleteDraftImage={this._handleDeleteDraftImage}
                handleStartUploadClick={this._handleStartUploadClick}
              />
            </TabPane>
            <TabPane className="tab-content--custom__tab-pane" tabId="productDetail">
              <ProductContainer
                isLoading={this._isLoading()}
                productVariant={product_variant}/>
            </TabPane>
            <TabPane className="tab-content--custom__tab-pane" tabId="sellerDetail">
              <UserContainer
                isLoading={this._isLoading()}
                user={user}
                sellerVerificationList={user&&user.seller_verification_info}
              />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    )
  }
	render(){
    return(
      <div className="animated fadeIn">
        <Row>
          <Card body>
            {this._renderContent()}
          </Card>
        </Row>
      </div>
    )
  }

}

const mapStateToProps=({sellRequest, rack, auth: { isFetch, isLogged, roles, id, email }, user, imageUpload})=> {
	return {
    sellRequest,
    rackDetail: rack.details,
    userSetting: user.user_setting,
    guardData: { isFetch, isLogged, roles, id, email },
    imageUpload
	}
}

const mapDispatchToProps=(dispatch)=>{
	return {
		deleteSellRequest: id => dispatch(deleteSellRequest(id)),
		forceHolidayMode: payload => dispatch(forceHolidayMode(payload)),
		updateSellRequest: (id, payload) => dispatch(updateSellRequest(id, payload)),
    getDetail:(id)=>dispatch(getDetailUserSell(id)),
    deleteSellImage: (image) => dispatch(deleteSellImageApi(image)),
    newImage: (image, payload, result) => dispatch(addSellImageApi(image, payload, result)),
    modifyImage: (id, image, payload, result) => dispatch(updateSellImage(id, image, payload, result)),
    uploadImage: (payload, rawImages) => dispatch(uploadImage(payload, rawImages)),
    deleteImage: (payload) => dispatch(deleteImage(payload)),
    getUserSellJournal: (id, q) => dispatch(getUserSellJournal(id, q)),
    attachRack: (id, p) => dispatch(attachRack(id, p)),
    detachRack: (id, p) => dispatch(detachRack(id, p))
	}
}

const enhance = connect(mapStateToProps,mapDispatchToProps);

export default enhance(privateView(SellRequestDetail, ['supervisor','sale_supervisor','cashier']));
